let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2F3bE")).then(() => parcelRequire('3N3RQ'));